var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.componentName,_vm._b({tag:"component",on:{"error":function($event){return _vm.$emit('error')}}},'component',{ ..._vm.componentAttributes, width: _vm.width, height: _vm.height },false))
}
var staticRenderFns = []

export { render, staticRenderFns }